import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, withModifiers as _withModifiers, createVNode as _createVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "tw-mb-8" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 2,
  class: "tw-text-center"
}
const _hoisted_4 = {
  key: 3,
  class: "tw-text-left"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 4,
  class: "tw-text-center tw-mx-auto"
}
const _hoisted_8 = {
  key: 5,
  class: "sf-form-group tw-text-center"
}
const _hoisted_9 = {
  key: 0,
  class: "sf-form-group tw-text-center"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "sf-btn-primary"
}, "Submit", -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MathAnswerWidgetLoader = _resolveComponent("MathAnswerWidgetLoader")!
  const _component_MathAnwerFormButton = _resolveComponent("MathAnwerFormButton")!
  const _component_RenderMathQuestion = _resolveComponent("RenderMathQuestion")!
  const _component_MathJsonAnswerField = _resolveComponent("MathJsonAnswerField")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"])),
    ref: "answerForm"
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.question.answerKind == 'custom')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : (_ctx.question.answerKind == 'widget')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.question.answerUi?.widget)
                ? (_openBlock(), _createBlock(_component_MathAnswerWidgetLoader, {
                    key: 0,
                    widget: _ctx.question.answerUi.widget,
                    onAnswer: _ctx.widgetOnAnswer
                  }, null, 8, ["widget", "onAnswer"]))
                : _createCommentVNode("", true)
            ], 64))
          : (_ctx.question.answerKind == 'buttons')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (v, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "tw-inline-block md:tw-m-2"
                  }, [
                    _createVNode(_component_MathAnwerFormButton, {
                      format: _ctx.question.answerUi?.optionsFormat,
                      "button-data": v,
                      onClick: _withModifiers(($event: any) => (_ctx.onButton(v.value)), ["prevent"])
                    }, null, 8, ["format", "button-data", "onClick"])
                  ]))
                }), 128))
              ]))
            : (_ctx.question.answerKind == 'singleop' 
          || _ctx.question.answerKind == 'multiop')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (v, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: "tw-my-8"
                    }, [
                      _createElementVNode("label", null, [
                        (_ctx.question.answerKind == 'multiop')
                          ? (_openBlock(), _createElementBlock("input", {
                              key: 0,
                              type: "checkbox",
                              value: v.value,
                              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onMultiselect && _ctx.onMultiselect(...args)))
                            }, null, 40, _hoisted_5))
                          : _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 1,
                              type: "radio",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.simpleAnswer) = $event)),
                              value: v.value,
                              class: "tw-inline-block"
                            }, null, 8, _hoisted_6)), [
                              [_vModelRadio, _ctx.simpleAnswer]
                            ]),
                        _createVNode(_component_RenderMathQuestion, {
                          "question-kind": _ctx.question.answerUi?.optionsFormat || 'text',
                          question: v.label || v.value,
                          class: "tw-inline-block tw-ml-4"
                        }, null, 8, ["question-kind", "question"])
                      ])
                    ]))
                  }), 128))
                ]))
              : (_ctx.question.answerFields)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.answerFields, (v) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: v.name,
                        class: "sf-form-group tw-inline-block tw-mx-2"
                      }, [
                        (v.label)
                          ? (_openBlock(), _createElementBlock("label", {
                              key: 0,
                              class: _normalizeClass('g-color-' + v.color)
                            }, _toDisplayString(v.label), 3))
                          : _createCommentVNode("", true),
                        (_ctx.jsonAnswer[v.name] !== undefined)
                          ? (_openBlock(), _createBlock(_component_MathJsonAnswerField, {
                              key: 1,
                              modelValue: _ctx.jsonAnswer[v.name],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.jsonAnswer[v.name]) = $event),
                              "answer-data": v,
                              class: _normalizeClass(["sf-form-control answer-field", '!tw-border-actcolor' + v.color])
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "answer-data", "class"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.simpleAnswer) = $event)),
                      class: "sf-form-control answer-field"
                    }, null, 512), [
                      [_vModelText, _ctx.simpleAnswer]
                    ])
                  ]))
    ]),
    (_ctx.question.answerKind != 'buttons')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
      : _createCommentVNode("", true)
  ], 544))
}